export default {
  notes: [],
  notesMeta: {},
  notesFilterOptionsByScope: {},
  activeNotesMemberId: '',
  researcherClients: [],
  researcherProjectsById: {},
  sharepointFilesByClient: {},
  sharepointFilesLoadingByClient: {},
  sharepointFilesErrorByClient: {},
  archiveFilesByClient: {},
  archiveFilesLoadingByClient: {},
  archiveFilesErrorByClient: {},
  researchMembersUpdating: false,
  notesLoading: false,
  notesLoadingRequestId: 0,
  note: null,
  noteLoading: false,
  noteUpdateLoading: false,
  unifiedSearchList: [],
  unifiedSearchMeta: {},
  unifiedSearchLoading: false,
  savedClients: {
    version: 4,
    selectedResearcher: null,
    selectedClientReference: {},
    otherSelectedClients: [],
  },
};
